import { useStoreon } from 'storeon/react';
import { LoyaltyRegistrationModalStore } from '../../../reducers';
import { useEffectOnce } from 'common/hooks';
import { REGISTRATION_MODAL } from '../../../actions';
import { sendShowLoyaltyRegistrationModalEvent } from 'utils/ga-events';

export const OPEN_LOYALTY_REGISTRATION_MODAL_EVENT = 'OPEN_LOYALTY_REGISTRATION_MODAL';

export interface IOpenLoyaltyRegistrationModalEventDetails {
  from: string;
}

export const useLoyaltyRegistrationModalEvents = () => {
  const { dispatch } = useStoreon<LoyaltyRegistrationModalStore>('loyaltyRegistrationModal');

  const openModal = (ev: Event) => {
    dispatch(REGISTRATION_MODAL.open);

    const details = (ev as CustomEvent<IOpenLoyaltyRegistrationModalEventDetails>).detail;

    if (details.from) {
      sendShowLoyaltyRegistrationModalEvent(details.from);
    }
  };

  useEffectOnce(() => {
    window.addEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);

    return () => {
      window.removeEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);
    };
  });

  // HACK: Для юнит тестов
  return {
    openModal,
  };
};
